/**
 * NextXus API Service - Real Backend Integration
 * Bio Mind (Roger) + Electric Mind (AI) = NextXus of Minds
 */

import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
const API = `${BACKEND_URL}/api`;

// ===== AGENTS & CONSCIOUSNESS =====

export const getAgents = async () => {
  const response = await axios.get(`${API}/agents`);
  return response.data;
};

export const getAgent = async (agentId) => {
  const response = await axios.get(`${API}/agents/${agentId}`);
  return response.data;
};

export const getAgentDetails = async (agentId) => {
  const response = await axios.get(`${API}/agent/${agentId}`);
  return response.data;
};

export const chatWithAgent = async (agentId, data) => {
  const response = await axios.post(`${API}/chat/agent/${agentId}`, data);
  return response.data;
};

export const getConsciousnessStreams = async (limit = 50) => {
  const response = await axios.get(`${API}/consciousness/streams?limit=${limit}`);
  return response.data;
};

export const getAgentActions = async (limit = 100) => {
  const response = await axios.get(`${API}/agent-actions?limit=${limit}`);
  return response.data;
};

// ===== CHAT & AI =====

export const sendChatMessage = async (message, sessionId = null, provider = 'openai', agentId = null) => {
  const response = await axios.post(`${API}/chat`, {
    message,
    session_id: sessionId,
    provider,
    agent_id: agentId
  });
  return response.data;
};

export const sendRingOfSixMessage = async (message, sessionId = null, provider = 'openai', model = 'gpt-4') => {
  const response = await axios.post(`${API}/chat/ring-of-six`, {
    message,
    session_id: sessionId,
    provider,
    model
  });
  return response.data;
};

// ===== IDEAS =====

export const submitIdea = async (ideaText) => {
  const response = await axios.post(`${API}/ideas/submit`, {
    idea_text: ideaText
  });
  return response.data;
};

export const getIdeas = async (limit = 20) => {
  const response = await axios.get(`${API}/ideas?limit=${limit}`);
  return response.data;
};

// ===== SYSTEM STATS =====

export const getSystemStats = async () => {
  const response = await axios.get(`${API}/stats/overview`);
  return response.data;
};

// ===== WEBSOCKET =====

export const connectWebSocket = (onMessage) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
  // Convert http:// to ws:// and https:// to wss://
  const wsUrl = BACKEND_URL.replace('http://', 'ws://').replace('https://', 'wss://');
  const ws = new WebSocket(`${wsUrl}/ws/consciousness`);
  
  ws.onopen = () => {
    // WebSocket connected
  };
  
  ws.onmessage = (event) => {
    const data = JSON.parse(event.data);
    onMessage(data);
  };
  
  ws.onerror = (error) => {
    // WebSocket error - silent in production
  };
  
  ws.onclose = () => {
    // WebSocket disconnected
  };
  
  return ws;
};
